"use client";
import {
  __name
} from "../../../chunk-SHUYVCID.js";

// src/sections/core/contact/contact-centered.tsx
import { Icon } from "@core/icons";
import { Button } from "@core/ui/components/atoms/button";
import { Container } from "@core/ui/components/atoms/container";
import { Input } from "@core/ui/components/atoms/input";
import { Label } from "@core/ui/components/atoms/label";
import { Separator } from "@core/ui/components/atoms/separator";
import { Textarea } from "@core/ui/components/atoms/textarea";
import { match } from "ts-pattern";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function ContactFormFieldCentered({ field }) {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1.5", children: [
    /* @__PURE__ */ jsx(Label, { htmlFor: field.id, children: field.label }),
    match(field.type).with("text", "email", "tel", (type) => /* @__PURE__ */ jsx(
      Input,
      {
        id: field.id,
        name: field.id,
        type,
        placeholder: field.placeholder,
        required: field.required
      }
    )).with("textarea", () => /* @__PURE__ */ jsx(
      Textarea,
      {
        id: field.id,
        name: field.id,
        placeholder: field.placeholder,
        required: field.required,
        rows: 4
      }
    )).with("select", () => /* @__PURE__ */ jsx(
      Input,
      {
        id: field.id,
        name: field.id,
        type: "text",
        placeholder: field.placeholder,
        required: field.required
      }
    )).exhaustive()
  ] });
}
__name(ContactFormFieldCentered, "ContactFormFieldCentered");
function formatAddressCentered(address) {
  const parts = [
    address.line1,
    ...address.line2 != null ? [address.line2] : [],
    [address.city, address.region, address.postalCode].filter(Boolean).join(", "),
    address.country
  ];
  return parts;
}
__name(formatAddressCentered, "formatAddressCentered");
function ContactCentered({ content, themeId }) {
  if (content == null) {
    return null;
  }
  const { heading, description, email, phone, address, formConfig } = content;
  return /* @__PURE__ */ jsx("section", { className: "bg-background px-6 py-16 m\
d:py-24", "data-theme": themeId, children: /* @__PURE__ */ jsx(Container, { size: "\
lg", children: /* @__PURE__ */ jsxs("div", { className: "mx-auto max-w-2xl text-\
center", children: [
    /* @__PURE__ */ jsx("h2", { className: "text-3xl font-bold tracking-tight", children: heading }),
    description != null && /* @__PURE__ */ jsx("p", { className: "mt-4 text-lg t\
ext-muted-foreground", children: description }),
    (email != null || phone != null || address != null) && /* @__PURE__ */ jsxs(
    "div", { className: "mt-8 flex flex-wrap items-center justify-center gap-8",
    children: [
      email != null && /* @__PURE__ */ jsxs("div", { className: "flex items-cent\
er gap-2", children: [
        /* @__PURE__ */ jsx(Icon, { icon: "Mail", className: "size-4 text-primar\
y" }),
        /* @__PURE__ */ jsx(
          "a",
          {
            href: `mailto:${email}`,
            className: "text-sm text-muted-foreground hover:text-foreground",
            children: email
          }
        )
      ] }),
      phone != null && /* @__PURE__ */ jsxs("div", { className: "flex items-cent\
er gap-2", children: [
        /* @__PURE__ */ jsx(Icon, { icon: "Phone", className: "size-4 text-prima\
ry" }),
        /* @__PURE__ */ jsx(
          "a",
          {
            href: `tel:${phone}`,
            className: "text-sm text-muted-foreground hover:text-foreground",
            children: phone
          }
        )
      ] }),
      address != null && /* @__PURE__ */ jsxs("div", { className: "flex items-ce\
nter gap-2", children: [
        /* @__PURE__ */ jsx(Icon, { icon: "MapPin", className: "size-4 text-prim\
ary" }),
        /* @__PURE__ */ jsx("span", { className: "text-sm text-muted-foreground",
        children: formatAddressCentered(address).join(", ") })
      ] })
    ] }),
    formConfig != null && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Separator, { className: "my-10" }),
      /* @__PURE__ */ jsxs(
        "form",
        {
          action: formConfig.formAction,
          method: "POST",
          className: "flex flex-col gap-4 text-left",
          "data-success-message": formConfig.successMessage,
          children: [
            formConfig.fields.map((field) => /* @__PURE__ */ jsx(ContactFormFieldCentered,
            { field }, field.id)),
            /* @__PURE__ */ jsx(Button, { type: "submit", className: "mt-2 w-ful\
l", children: formConfig.submitText ?? "Send Message" })
          ]
        }
      )
    ] })
  ] }) }) });
}
__name(ContactCentered, "ContactCentered");
export {
  ContactCentered
};
